import React from 'react';
import Grid, { CardGridProps as CardGridCopyProps } from 'antd/lib/card';

export type CardGridProps = CardGridCopyProps;

const ProCardGrid: React.FC<CardGridProps> = (props) => {
  const { children, ...resProps } = props;

  return <Grid {...resProps}>{children}</Grid>;
};

export default ProCardGrid;
